import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../../toolkit/uicomponentcss';
import { Fonts } from '../../../../utils/resources/fonts';
import { Colors } from '../../../../utils/resources/colors';
export interface ToneDetailsPopupCSSStyle extends UIComponentCSSStyle
{
    getHeaderDivCSSStyle(): object;
    getTitleCSSStyle(): object;
    getCloseIconDivCSSStyle(): object;
    getCloseIconCSSStyle(): object;
    getToneImgDivCSSStyle(): object;
    getRowDivCSSStyle(): object;
    getToneDetailsDivCSSStyle(): object;
    getToneNameCSSStyle(): object;
    getArtistNameCSSStyle(): object;
    getToneDetailsPopupButtonCSSStyle(): object;
    getDoUHaveAccountCSSStyle(): object;
    getSignUpCSSStyle(): object;
    getMobileToneDetailsDivCSSStyle():object;
    getMobileImageToneDetailsDivCSSStyle():object;
    getMobileTitleCSSStyle(): object;
    getMobileCloseIconCSSStyle(): object;
    getMobileToneImgDivCSSStyle():object;
}

export class ToneDetailsPopupCSSStyleImpl extends UIComponentCSSStyleImpl implements ToneDetailsPopupCSSStyle
{
    getWrapperCSSStyle(): object
    {
        return {
            width: "100%",
            height: "300px",
            backgroundColor: this.getResources().getColor(Colors.color_5),
            borderRadius: "8px 8px 0px 0px",
            flexFlow: "row wrap",
            position:'relative',
            objectFit:'fill',
            justifyContent:'center',
            itemAlign:'center'
            
        };
    }

    getHeaderDivCSSStyle(): object 
    {
        return {
            backgroundColor: this.getResources().getColor(Colors.color_18),
            width: "100%",
            height: "60px",
            display: "flex",
            borderRadius: "8px 8px 0px 0px",
        };
    }

    getTitleCSSStyle(): object {
        return {
            width: "380px",
            height: "40px",
            fontWeight: "300",
            letterSpacing: 0,
            // paddingLeft: "40px",
            // paddingRight: "0px",
            fontSize: this.getResources().getFont(Fonts.h12),
            color:this.getResources().getColor(Colors.color_19),
            lineHeight: "40px",
            marginTop: "7px",
            textAlign: "center"
        };
    }

    getMobileTitleCSSStyle(): object {
        return {
            width: "97%",
            height: "40px",
            fontWeight: "300",
            letterSpacing: 0,
            // paddingLeft: this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH ? "40px" : "0px",
            // paddingRight: "0px",
            fontSize: "18px",
            color:this.getResources().getColor(Colors.color_19),
            lineHeight: "40px",
            marginTop: "7px",
            textAlign: "center"
        };
    }
    
    getCloseIconDivCSSStyle(): object 
    {
        return {
            height: "60px",
            width: "60px",
            justifyContent: "center",
            textAlign: "center",
            alignItems: "center",
            display: "inline-block",
            cursor: "pointer"
        };
    }

    getCloseIconCSSStyle(): object 
    {
        return {
            height: "12px",
            width: "12px",
            marginTop: "22px",
            cursor: "pointer"
        };
    }

    getMobileCloseIconCSSStyle(): object 
    {
        return {
            height: "12px",
            width: "12px",
            marginRight: "10px",
            marginTop: "22px",
            cursor: "pointer"
        };
    }

    getToneImgDivCSSStyle(): object 
    {
        return {
            height: "202px",
            width: "100%",
            display: "flex",
            justifyContent:'center',
            itemAlign:'center',
            // left:"28.5%",
            textAlign:'center',
            backgroundColor: this.getResources().getColor(Colors.color_5),
            marginTop: "30px",
            // paddingLeft: "32px",
            // paddingRight: "32px",
            zIndex:'0px',
            position:'absolute'
        };
    }

    getMobileToneImgDivCSSStyle():object
    {
        return {
            height: "202px",
            width: "100%",
            display:"flex",
            justifyContent:'center',
            itemAlign:'center',
            // left:"21.5%",
            textAlign:'center',
            backgroundColor: this.getResources().getColor(Colors.color_5),
            marginTop: "30px",
            // paddingLeft: "32px",
            // paddingRight: "32px",
            zIndex:'0px',
            position:'absolute'
        };
    }
    getMobileToneDetailsDivCSSStyle():object{
        return{
            paddingTop: "8px",
            borderRadius:'0px 0px 8px 8px',
            // paddingLeft:'20px',
            top:'132px',
            position:'absolute',
            // paddingRight:'10px',
            // alignItems:'left',
            height: "70px",
            // opacity:'5%',
            width:"189px",
            background:"rgba(0,0,0,0.5)",
        };
    }
    getMobileImageToneDetailsDivCSSStyle():object{
        return{
            paddingTop: "8px",
            borderRadius:'0px 0px 8px 8px',
            paddingLeft:'20px',
            top:'132px',
            position:'absolute',
            paddingRight:'10px',
            alignItems:'left',
            height: "70px",
            width: "189px",
            // opacity:'5%',
            background:"rgba(0,0,0,0.5)",
        };
    }
    getToneDetailsDivCSSStyle(): object 
    {
        return {
            paddingTop: "8px",
            borderRadius:'0px 0px 8px 8px',
            paddingLeft:'20px',
            top:'132px',
            // left:'0%',
            position:'absolute',
            // paddingRight:'10px',
            // alignItems:'left',
            height: "70px",
            width: "189px",
            // opacity:'5%',
            background:"rgba(0,0,0,0.5)",
        };
    }

    getToneNameCSSStyle(): object {
       return {
        width: "100%",
        height: "30px",
        minWidth:'50px',
        fontWeight: "900",
        letterSpacing: 0,
        fontFamily: this.getResources().getFontFamily(),
        fontSize: this.getResources().getFont(Fonts.h9),
        color:this.getResources().getColor(Colors.color_5),
        lineHeight: "30px",
        // textAlign: "left",
        overflow: 'hidden',
        textOverflow: 'ellipsis'
       };
    }

    getArtistNameCSSStyle(): object {
        return {
            width: "100%",
            minWidth:'50px',
            height: "20px",
            fontFamily: this.getResources().getFontFamily(),
            color:this.getResources().getColor(Colors.color_5),
            fontSize: this.getResources().getFont(Fonts.h7),
            letterSpacing: 0,
            lineHeight: "20px",
            // textAlign: "left",
            overflow: 'hidden',
            fontWeight:300,
            textOverflow: 'ellipsis'
        };
    }

    getSignUpRowDivCSSStyle(): object {
        return {
            marginTop: "30px",
            display: "flex",
            position: "relative",
            flexDirection: "row",
            flexFlow: "row wrap",
        };
    }

    getRowDivCSSStyle(): object 
    {
        return {
            marginTop: "15px",
            display: "flex",
            position: "relative",
            flexDirection: "row",
            flexFlow: "row wrap",
        };
    }

    getRememberMeCSSStyle(): object 
    {
        return {
            display: "inline-block",
            textAlign: "left",
            height: "20px",
            letterSpacing: 0,
            fontSize: this.getResources().getFont(Fonts.h5),
            color:this.getResources().getColor(Colors.color_7),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "20px",
            paddingLeft: "10px",
            flex: 2
        };
    }

    getForgotPasswordCSSStyle(): object 
    {
        return {
            display: "inline-block",
            textAlign: "left",
            height: "20px",
            letterSpacing: 0,
            fontSize: this.getResources().getFont(Fonts.h7),
            color:this.getResources().getColor(Colors.color_2),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "20px",
            fontWeight: 600,
            cursor: "pointer"
        };
    }

    getToneDetailsPopupButtonCSSStyle(): object 
    {
        return {
            marginTop: "50px",
            width:'180px'
        };
    }

    getDoUHaveAccountCSSStyle(): object 
    {
        return {
            display: "inline-block",
            textAlign: "left",
            height: "20px",
            letterSpacing: 0,
            fontSize: this.getResources().getFont(Fonts.h5),
            color:this.getResources().getColor(Colors.color_7),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "20px",
        };
    }

    getSignUpCSSStyle(): object 
    {
        return {
            display: "inline-block",
            textAlign: "left",
            paddingRight:'5px',
            height: "20px",
            letterSpacing: 0,
            fontWeight: 600,
            fontSize: this.getResources().getFont(Fonts.h7),
            color:this.getResources().getColor(Colors.color_2),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "20px",
            paddingLeft: "10px",
            cursor: "pointer"
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/tonedetailspopup/tonedetailspopupcss.tsx